var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 69,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.84 60.022l-.009-.028-.01-.027-4.68-12.032 3.98-.213h.009l.01-.002c1.788-.13 2.814-2.385 1.301-3.729l-15.994-14.85v-.001l-.009-.008c-1.214-1.1-3.21-.392-3.4 1.304v.016l-.002.015-1.755 21.762c-.17 1.886 2.014 3.023 3.48 1.862l.008-.006.007-.006 3.078-2.532 4.68 12.032c.443 1.14 1.65 1.67 2.788 1.227l5.272-2.051c1.098-.427 1.587-1.678 1.246-2.733z",
    fill: "#0025FF",
    stroke: "#fff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.515 9.893c-.27-.694-1.09-1.054-1.831-.806-.694.27-1.054 1.09-.806 1.831l4.264 10.96c.135.347.409.64.746.788.337.149.738.153 1.085.018.693-.27 1.054-1.09.805-1.83L25.515 9.892zM24.041 27.357a1.415 1.415 0 0 0-.728-1.873l-10.744-4.726a1.415 1.415 0 0 0-1.873.729 1.415 1.415 0 0 0 .729 1.873l10.743 4.726a1.415 1.415 0 0 0 1.873-.73zM22.098 33.344l-10.96 4.264c-.695.27-1.055 1.089-.806 1.83.135.347.408.64.746.788.337.149.738.153 1.085.018l10.96-4.264c.694-.27 1.054-1.088.805-1.83-.318-.715-1.137-1.075-1.83-.806zM41.205 28.468c.337.148.738.152 1.084.017l10.96-4.264c.694-.27 1.055-1.089.806-1.83-.27-.694-1.089-1.054-1.83-.806l-10.96 4.264c-.695.27-1.055 1.088-.806 1.83.162.417.456.661.746.789zM35.764 22.797a1.415 1.415 0 0 0 1.873-.729l4.726-10.743a1.415 1.415 0 0 0-.728-1.873 1.415 1.415 0 0 0-1.873.728l-4.726 10.744a1.415 1.415 0 0 0 .728 1.873z",
    fill: "#0025FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.3eeef196c8471327cd905b8c4b597f81.svg";
export { ForwardRef as ReactComponent };